import type { AxiosError } from 'axios';

export const formatterApiErrors = (err: AxiosError<any>): string => {
  if (err?.response?.data?.message && typeof err.response.data.message === 'string') {
    return err.response.data.message;
  }

  if (err?.response?.data?.message?.message && typeof err.response.data.message.message === 'string') {
    return err.response.data.message.message;
  }

  if (err?.response?.data?.message?.error?.customer && typeof err.response.data.message.error.customer === 'string') {
    return err?.response?.data?.message?.error?.customer;
  }

  if (err?.response?.data?.message?.error?.title && typeof err.response.data.message.error.title === 'string') {
    return err?.response?.data?.message?.error?.title;
  }

  if (
    err?.response?.data?.message?.error &&
    typeof err.response.data.message.error === 'object' &&
    typeof err.response.data.message.error[Object.keys(err.response.data.message.error)[0]] === 'string'
  ) {
    return err.response.data.message.error[Object.keys(err.response.data.message.error)[0]];
  }

  if (err?.response?.data?.message?.error && typeof err.response.data.message.error[0] === 'string') {
    return err.response.data.message.error[0];
  }

  return 'Algo deu errado, tente novamente...';
};

export default formatterApiErrors;
